<template>
  <div>
    <div class="row my-4">
      <div class="col-6">
        <span class="option-list__item">
          <slot name="index" />
          {{ option.name }}
        </span>

        <p v-if="option.description" class="p--description">{{ option.description }}</p>
      </div>

      <div class="col-6">
        <div v-if="$schema.$model.edit" class="row">
          <w-input class="col-8" title :model="$schema.value" />

          <div class="col-4">
            <button
              aria-label="Zapisz"
              class="btn btn-icon rounded-circle hover-effect-dot waves-effect waves-themed btn-success mr-2"
              @click="save"
            >
              <i class="fal fa-fw fa-save" />
            </button>

            <button
              aria-label="Anuluj"
              class="btn btn-icon rounded-circle hover-effect-dot waves-effect waves-themed btn-danger"
              @click="cancelEdit"
            >
              <i class="fal fa-fw fa-ban" />
            </button>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-8 pt-2">
            {{ $schema.$model.value }}
          </div>

          <div class="col-4">
            <button
              aria-label="Edytuj"
              class="btn btn-icon rounded-circle hover-effect-dot waves-effect waves-themed btn-primary"
              @click="enableEdit"
            >
              <i class="fal fa-fw fa-edit" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/optionValue.schema';

// @vuese
// Pojedyńcza wartość opcji
// @group Option
export default {
  mixins: [formMixin, notificationsMixin],
  schema,
  props: {
    // Pojedyńcza opcja
    option: {
      type: Object,
      required: false
    },
    // Typ encji
    entityType: {
      type: String,
      required: true
    },
    // Identyfikator encji
    entityId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      model: {},
      previousModel: undefined
    };
  },
  computed: mapState({
    optionValue(state) {
      return state.optionValue.list.find(optionValueListItem => optionValueListItem.optionId === this.option.id);
    }
  }),
  watch: {
    optionValue(value) {
      this.$schema.$value.value = value ? value.value : this.option.defaultValue;
    }
  },
  mounted() {
    this.$schema.$value.entityType = this.entityType;
    this.$schema.$value.entityId = this.entityId;
    this.$schema.$value.optionId = this.option.id;
  },
  methods: {
    // @vuese
    // Włączanie edycji pola
    enableEdit() {
      this.previousModel = JSON.parse(JSON.stringify({ ...this.$schema.$model }));
      this.$schema.$model.edit = true;
    },
    // @vuese
    // Wyłączanie edycji pola
    cancelEdit() {
      this.$schema.$model.edit = false;
      this.$schema.$setData(this.previousModel);
    },
    // @vuese
    // Zapisanie wartości opcji
    save() {
      if (this.$schema.$validateAll()) {
        this.saveRequest()
          .then(() => {
            this.$schema.$model.edit = false;
            this.notifySuccess(Successes.OPTION_UPDATED);
          })
          .catch(error => this.notifyError(Errors.OPTION_CANNOT_UPDATE));
      }
    },
    // @vuese
    // Zapisanie opcji
    saveRequest() {
      if (!this.optionValue) {
        return this.$store.dispatch('optionValue/add', this.$schema.$getData());
      } else {
        return this.$store.dispatch('optionValue/update', { id: this.optionValue.id, ...this.$schema.$getData() });
      }
    }
  }
};
</script>

<style>
.p--description {
  font-size: 0.875rem;
  margin-bottom: 0;
}

.option-list__item {
  font-size: 1.0625rem;
}
</style>
